<script lang="ts">
  import { titleFormat } from '$lib/config';

  export let robots: string;
  export let title: string;
  export let description: string;
  export let canonical: string;
  export let og: {
    title: string;
    description: string;
    type: string;
    url?: string;
  };
</script>

<meta name="robots" content="{robots}" />

<title>{titleFormat.replace('{title}', title)}</title>
<meta name="og:title" content="{og.title}" />

<meta name="description" content="{description}" />
<meta name="og:description" content="{og.description}" />

<link rel="canonical" href="{canonical}" />
<meta name="og:url" content="{og.url || canonical}" />

<meta name="og:type" content="{og.type}" />
